export default "__VITE_ASSET__Dwvm0JQN__"